import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import { ExportService } from 'app/reports/services/export.service';

@Component({
  selector: 'app-operation-theatre-master',
  templateUrl: './operation-theatre-master.component.html',
  styleUrls: ['./operation-theatre-master.component.scss']
})
export class OperationTheatreMasterComponent implements OnInit {
  searchValue: any;
  TheatreName: any;
  GroupName: any;
  isActivevalue: any;
  TheatreId: any;
  enabledisablebtn: boolean = false;
  BranchName: any;
  BranchId: any;
  filterValue: any;
  constructor(private exportdata: ExportService, public branchMasterService: BranchMatserService, public dashboardService: DashboardService,
    public authService: AuthService) { }

  ngOnInit(): void {
    this.enabledisablebtn = true;
    this.getOperationTheatreMaster();
  }
  enableButton($event) {

    if (this.TheatreName == '' || this.GroupName == '' || this.BranchName == "") {
      this.enabledisablebtn = true;
    } else {
      this.enabledisablebtn = false;
    }
  }
  searchRecordModal() {
    this.searchValue = '';
    document.getElementById("searchRecordModal").style.display = "block";
  }
  closeSearchRecordModal() {
    document.getElementById("searchRecordModal").style.display = "none";
  }
  OpTheatreArray: any = [];
  filteredOpTheatreArray: any = [];
  getOperationTheatreMaster() {
    this.TheatreName = '';
    this.GroupName = '';
    this.isActivevalue = '';
    this.TheatreId = '';
    this.BranchName = '';
    this.OpTheatreArray = [];
    this.branchMasterService.getOperationTheatreMaster().subscribe((x: any) => {
      this.OpTheatreArray = x;
      this.filteredOpTheatreArray = x;
    });

  }

  onSearchValueChange() {
    const val = this.searchValue.toLowerCase();
    this.filteredOpTheatreArray = this.OpTheatreArray.filter(item =>
      item.theatreName?.toLowerCase().includes(val) ||
      item.groupName?.toLowerCase().includes(val) ||
      item.branchName?.toLowerCase().includes(val)
    );
  }

  checkChange(event) {
    this.isActivevalue = event.checked;
  }
  onchnageBranch(e: any) {

    this.BranchName = e.option.value;
    this.BranchId = e.option.id;
    this.enableButton(e.option.value);
  }
  selectRow(id) {
    this.enabledisablebtn = false;
    this.TheatreId = id;
    var OpTheatreData = this.OpTheatreArray.filter(item => item.pK_OTTheatreId == id);
    this.TheatreName = OpTheatreData[0]?.theatreName;
    this.GroupName = OpTheatreData[0]?.groupName;
    this.BranchName = OpTheatreData[0]?.branchName;
    this.BranchId = OpTheatreData[0]?.fk_BranchID;
    this.isActivevalue = OpTheatreData[0]?.isActive;
    document.getElementById("searchRecordModal").style.display = "none";
  }
  ClearData() {
    this.enabledisablebtn = true;
    this.TheatreName = '';
    this.GroupName = '';
    this.isActivevalue = '';
    this.BranchName = '';
    this.TheatreId = 0;
  }
  saveOpTheatreMaster() {
    const selectedBranch = this.authService.Branches.find(
      (branch) => branch.branchName === this.BranchName
    );

    if (!selectedBranch) {
      this.dashboardService.openSnackBar("Please select a valid branch", "OK");
      return;
    }
    if (this.TheatreId > 0) {
      let PayLoad = {
        "OperationTheatreMaster": {
          "pK_OTTheatreId": this.TheatreId,
          "theatreName": this.TheatreName,
          "groupName": this.GroupName,
          "isActive": this.isActivevalue ? true : false,
          "fk_BranchID": this.BranchId,
          "isEdit": true,
          "isDelete": false
        }
      }

      this.branchMasterService.InsertOperationTheatreMaster(PayLoad).subscribe(data => {
        if (data.statusCode == 1) {
          this.enabledisablebtn = true;
          this.dashboardService.openSnackBar("Record Updated Successfully ", "OK");
          this.getOperationTheatreMaster();
        } else if (data.statusCode == 10) {
          this.dashboardService.openSnackBar("Already exists in the list", "OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
        , err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });

    } else {

      // var OpTheatreData = this.OpTheatreArray.filter(item =>item.theatreName == this.TheatreName);  
      var OpTheatreData = this.OpTheatreArray.filter(item =>
        item.theatreName == this.TheatreName &&
        item.groupName == this.GroupName &&
        item.fk_BranchID == this.BranchId
      );
      if (OpTheatreData.length > 0) {
        this.dashboardService.openSnackBar("Already exists in the list", "OK");
        this.TheatreName = '';
        this.GroupName = '';
        this.isActivevalue = '';
        this.BranchName = '';
      } else {
        let PayLoad = {
          "OperationTheatreMaster": {
            "pK_OTTheatreId": 0,
            "theatreName": this.TheatreName,
            "groupName": this.GroupName,
            "isActive": this.isActivevalue ? true : false,
            "fk_BranchID": this.BranchId,
            "isEdit": false,
            "isDelete": false
          }
        }
        this.branchMasterService.InsertOperationTheatreMaster(PayLoad).subscribe(data => {
          if (data.statusCode == 1) {
            this.enabledisablebtn = true;
            this.dashboardService.openSnackBar("Record Saved Successfully ", "OK");
            this.getOperationTheatreMaster();

          } else if (data.statusCode == 10) {
            this.dashboardService.openSnackBar("Already exists in the list", "OK");
          } else {

            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
          , err => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          });
      }
    }
  }

  exportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById('showcontent');
    this.exportdata.Newexportxcel(element, 'OpTheatreMaster');
  }
}
